module.exports = __webpack_public_path__ + "img/jz4.2f13b769.png";